import tailwindConfig from "../../tailwind.config"

const themeColors = tailwindConfig.theme.colors

export const colors = {
  fpxRed: themeColors["fpx-red"],
  yellow: themeColors["yellow"],
  opaqueYellow: themeColors["opaque-yellow"],
  green: themeColors["green"],
  white: themeColors["white"],
  black: themeColors["black"],
  grey100: themeColors["grey-100"],
  grey300: themeColors["grey-300"],
  grey: themeColors["grey"],
  grey700: themeColors["grey-700"],
  grey900: themeColors["grey-900"],
  deepOcean: themeColors["deep-ocean"],
}